var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.headerContainer').outerHeight();


// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	$("[data-required]").each(function (index) {
		$(this).attr('required', true);
	});

	setInterval(function() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		} else if ($(window).scrollTop() < 5) {
			$('header').removeClass('nav-up').removeClass('nav-down');
		}
	}, 250);

	if ($('.menu-main a.active-parent').length) {
		var activeParent = $('.menu-main a.active-parent');
		activeParent.each(function() {
			$(this).parent().addClass('active');
		});
	}
	// if ($('.menu-main a.active-child').length) {
	// 	$('.menu-main a.active-child').parent().parent().parent().addClass('active');
	// }

	footer();

	heroSection();

});


// SCROLL

$(window).on('scroll', function(e) {

	didScroll = true;

});



// RESIZE

$(window).on('resize', function() {

	footer();

	setTimeout(() => {
		heroSection();
	}, 250);

});


// MENU

$(document).on('click', '.menu-main .with-menu-sub a', function(e) {
    e.stopPropagation();
    
    // Hide all submenus
	var btns = $('.menu-main .with-menu-sub > button');;
	btns.parent().removeClass('with-menu-sub-hover');
	btns.parent().find('button').attr('aria-expanded', false);
	btns.parent().find('.menu-sub').attr('aria-hidden', true);
	btns.parent().find('.menu-sub').hide();
});
$(document).on('click', function(e) {
    var $header = $('.menu-main');
    
    // Check if the click target is not within the header
    if (!$header.is(e.target) && $header.has(e.target).length === 0) {
        // Collapse all submenus
        var btns = $header.find('.with-menu-sub > button[aria-expanded="true"]');;
		btns.parent().removeClass('with-menu-sub-hover');
		btns.parent().find('button').attr('aria-expanded', false);
		btns.parent().find('.menu-sub').attr('aria-hidden', true);
		btns.parent().find('.menu-sub').hide();
    }
});
$(document).on('click', '.menu-main .with-menu-sub > button[aria-expanded="false"]', function(e) {
	e.stopPropagation();
	var btns = $('.menu-main .with-menu-sub > button');
	btns.parent().removeClass('with-menu-sub-hover');
	btns.parent().find('button').attr('aria-expanded', false);
	btns.parent().find('.menu-sub').attr('aria-hidden', true);
	btns.parent().find('.menu-sub').hide();
	$(this).parent().addClass('with-menu-sub-hover');
	$(this).parent().find('button').attr('aria-expanded', true);
	$(this).parent().find('.menu-sub').attr('aria-hidden', false);
	$(this).parent().find('.menu-sub').show();
	mainPageLinkOffset($(this));
});
$(document).on('click', '.menu-main .with-menu-sub > button[aria-expanded="true"]', function(e) {
	e.stopPropagation();
	var btns = $('.menu-main .with-menu-sub > button');
	btns.parent().removeClass('with-menu-sub-hover');
	btns.parent().find('button').attr('aria-expanded', false);
	btns.parent().find('.menu-sub').attr('aria-hidden', true);
	btns.parent().find('.menu-sub').hide();
	$('.menu-main .with-menu-sub').removeClass('with-menu-sub-hover');
	$(this).parent().find('button').attr('aria-expanded', false);
	$(this).parent().find('.menu-sub').attr('aria-hidden', true);
	$(this).parent().find('.menu-sub').hide();
});

$(window).on('resize', function() {
	var menuWithSubOpen = $('.menu-main .with-menu-sub > button[aria-expanded="true"]');
	if (menuWithSubOpen.length) {
		menuWithSubOpen.each(function(){
			mainPageLinkOffset($(this));
		});
	}
});
function mainPageLinkOffset(el) {
	// console.log('mainPageLinkOffset')
	var submenu = el.parent().find('.menu-sub');
	var menuMainPage = submenu.find('.menu-main-page');
	// console.log(submenu.attr('data-fullwidth'))
	if (submenu.attr('data-layout') == 'columns' && $(window).width() < 1920) {
		if ($(window).width() >= 1696 && submenu.attr('data-fullwidth') == 'false') {
			menuMainPage.removeAttr('style');
		} else {
			var offset = submenu.find('.menu-sub-column').first().offset().left;
			menuMainPage.css('padding-left', offset + 'px');
		}
	} else {
		menuMainPage.removeAttr('style');
	}
}





// FILTERS

$(".filter").on("mouseenter", function (e) {
	e.stopPropagation();
	$(this).find('.filter-options').fadeIn(300);
});
$(".filter").on("mouseleave", function (e) {
	e.stopPropagation();
	$(this).find('.filter-options').fadeOut(300);
});

$(document).on('click', '.filter', function(e) {
	// for touch screens only
	if (window.matchMedia('(hover: none)').matches) {
		$('.filter').not($(this)).removeClass('open');
		$('.filter').not($(this)).find('.filter-options').fadeOut(300);
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$(this).find('.filter-options').fadeOut(300);
		} else {
			$(this).addClass('open');
			$(this).find('.filter-options').fadeIn(300);
		}
	}
});




// SPECIALISTS
$(document).on('click', '.dpt[data-department]', function(e) {
	$('input[name="search-specialist"]').val('');
	// var letters = $('.specialists-section .letter');
	var dpt = $(this).data('department');
	var spc = $('.specialists-section .spc');
	// letters.hide();
	spc.hide();
	$('.dpt[data-department]').removeClass('active');
	$('.specialists-section .spc.' + dpt).show();
	$('.specialists-section .spc.' + dpt).parent().show();
	$(this).addClass('active');
	$('.specialists-section .filter .filter-name div').html($(this).text());
	if (dpt == 'all') {
		// letters.show();
		spc.show();
		$('.specialists-section .filter .filter-name div').html('Department');
	}
});

$(document).on('keyup', 'input[name="search-specialist"]', function(e) {
	// console.log($(this).val());
	// var letters = $('.specialists-section .letter');
	var spc = $('.specialists-section .spc');
	var dpt = $('.specialists-section .dpt');
	dpt.removeClass('active');
	$('.specialists-section .dpt[data-department="all"]').addClass('active');
	$('.specialists-section .filter .filter-name div').html('Department');
	const val = $(this).val();
	// letters.hide();
	spc.hide();
	$.getJSON( "/specialists.json", function( data ) {
		var items = data.data;
		if (items.length) {
			$.each(items, function(i, v) {
				var matcher = new RegExp(val, 'i');
				if (matcher.test(v.title)) {
					var spcId = v.id;
					$('.specialists-section .spc[data-id="' + spcId + '"]').show();
					$('.specialists-section .spc[data-id="' + spcId + '"]').parent().show();
				}
			});
		}
	});
	
});

$(document).on('submit', 'form.form-search-specialist', function(e) {
	e.preventDefault();
	$('input[name="search-specialist"]').trigger('keyup');
	return false;
	
});

$(document).on('click', '.specialists-section .spc', function(e) {
	var spcId = $(this).data('id');
	$('aside.panel-spc').fadeOut();
	$('aside.panel-spc[data-id="' + spcId + '"]').fadeIn('flex');
	$('body').addClass('overflow-hidden');
});

$(document).on('click', 'aside.panel-spc svg', function(e) {
	$('aside.panel-spc').fadeOut();
	$('body').removeClass('overflow-hidden');
});





function hasScrolled() {
	if ($('body.search-open').length) {
		return;
	}
	
	if ($('header .with-menu-sub-hover').length) {
		return;
	}
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.

    if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        if ($('header').hasClass('nav-down')) {
            $('header').removeClass('nav-down').addClass('nav-up');
        }
    } else {
        // Scroll Up
        if(st > navbarHeight && (st + $(window).height() < $(document).height())) {
            $('header').removeClass('nav-up').addClass('nav-down');
        } 
		var topOffset = 5;
		if ($(window).width() >= 1280) {
			topOffset = topOffset + $('.announcement-section[data-view="desktop"]').outerHeight();
		}

        if(st < topOffset) {
            $('header').removeClass('nav-up').removeClass('nav-down');
        }
    }
	if ($('header').hasClass('nav-down') && $('.quick-links-section').length && $(window).width() >= 1024) {
		$('.quick-links-section').addClass('nav-down');
	} else if ($('.quick-links-section').length) {
		$('.quick-links-section').removeClass('nav-down');
	}
    
    lastScrollTop = st;
} 

$('.hamburger').on("click", function(e) {
	e.stopPropagation();
	$(this).toggleClass('open');
	$('.headerContainer').add('body').toggleClass('mobile-menu-open');
	if ($(window).scrollTop() > 0) {
		$('header').addClass('nav-down');
	}
	if ($(this).hasClass('open')) {
		$(this).attr('aria-expanded', true);
		$('.menu-main-mobile-container').attr('aria-hidden', false);
	} else {
		$(this).attr('aria-expanded', false);
		$('.menu-main-mobile-container').attr('aria-hidden', true);
	}
});

$(document).on('click', '.menu-main-mobile li.with-menu-sub button', function(e) {
	e.stopPropagation();
	$(this).parent().toggleClass('open');
	var submenu = $(this).attr('data-submenu');
	if ($(this).parent().hasClass('open')) {
		if (submenu) {
			$('.submenu-screen .menu-sub[data-submenu="' + submenu + '"]').css('display', 'flex');
		}
		$('.menu-main-mobile-container').attr('data-submenu-open', true);
	} else {
		$('.submenu-screen .menu-sub').hide();
		$('.menu-main-mobile-container').attr('data-submenu-open', false);
	}
});
$(document).on('click', '.submenu-screen .back-link', function(e) {
	e.stopPropagation();
	$('.submenu-screen .menu-sub').hide();
	$('.menu-main-mobile-container').attr('data-submenu-open', false);
	$('.menu-main-mobile li.with-menu-sub').removeClass('open');
});

$(document).on('click', 'body.mobile-menu-open .backdrop', function(e) {
	e.stopPropagation();
	$('.hamburger').trigger('click');
});






// SEARCH
$(document).on('click', '.clear-search', function(e) {
	$(this).parent().find('input').val('');
	$(this).parent().find('input').trigger('focus');
	$(this).parent().find('input').trigger('keyup');
});




// TEAM
$(document).on('click', '.team-section .row-blocks .content', function(e) {
	var panel = $(this).data('panel');
	$('.team-section .row-blocks .panel').removeClass('open');
	$('.team-section .row-blocks .panel[data-panel="' + panel + '"]').addClass('open');
	if ($(window).width() >= 1024) {
		$('html, body').animate({
			scrollTop: $(".team-section .row-blocks").offset().top
		}, 500);
	} else {
		$('html, body').animate({
			scrollTop: $('.team-section .row-blocks .content[data-panel="' + panel + '"]').offset().top
		}, 500);
	}
});
$(document).on('click', '.team-section .close-panel', function(e) {
	e.stopPropagation();
	$('.team-section .row-blocks .panel').removeClass('open');
});




// SEARCH
$(document).on('click', 'body:not(.no-query) .toggle-search', function(e) {
	if ($('header .search-field-section').hasClass('open')) {
		$('header .search-field-section').removeClass('open');
		$('body').add('.headerContainer').removeClass('search-open');
		$(this).removeClass('open');
	} else {
		$('header .search-field-section').addClass('open');
		$('body').add('.headerContainer').addClass('search-open');
		$(this).addClass('open');
	}
});



// DIRECTORY
$(document).on('click', '.directory-section [data-panel]', function(e) {
	var panel = $(this).data('panel');
	if (panel) {
		if (panel == 'directory-panel-image' && $(window).width() < 1024) {

		} else {
			$('.directory-section .panel').removeClass('open');
			$('.directory-section .panel[data-panel="' + panel + '"]').addClass('open');
			$('.directory-section').css('min-height', 'auto');
			if ($(window).width() >= 1024) {
				$('.directory-section').css('min-height', $('.directory-section .panel[data-panel="' + panel + '"]').outerHeight());
				$('html, body').animate({
					scrollTop: $('.directory-section').offset().top
				}, 500);
			} else {
				$('html, body').animate({
					scrollTop: $('.directory-section [data-panel="' + panel + '"]').offset().top
				}, 500);
			}
		}
	}
});
$(document).on('click', '.directory-section .close-panel', function(e) {
	e.stopPropagation();
	$('.directory-section .panel').removeClass('open');
	$('.directory-section').css('min-height', 'auto');
});

$('.directory-section .location').on("mouseenter", function(e) {
	e.stopPropagation();
	var code = $(this).find('.short span').html();
	if (!code) {
		return false;
	}
	if (code == 'P') {
		$('svg.directory-map .' + code).css('fill', '#57bc85');
	} else if (code == 'BR') {
		$('svg.directory-map .' + code).css('fill', '#57bc85');
	} else {
		$('svg.directory-map .' + code).css('fill', '#131F4C');
	}
}).on("mouseleave", function(e) {
	e.stopPropagation();
	var code = $(this).find('.short span').html();
	if (!code) {
		return false;
	}
	if (code == 'P') {
		$('svg.directory-map .' + code).css('fill', '#ffffff');
	} else if (code == 'BR') {
		$('svg.directory-map .' + code).css('fill', '#131F4C');
	} else {
		$('svg.directory-map .' + code).css('fill', '#395FE4');
	}
});
$('svg.directory-map [class]').on("mouseenter", function(e) {
	e.stopPropagation();
	var codes = $(this).attr('class').split(' ');
	for (let i = 0; i < codes.length; ++i) {
		var code = codes[i];
		if (code != 'P' && code != 'BR') {
			$('svg.directory-map .' + code).css('fill', '#131F4C');
			$('.directory-section .location-' + code).addClass('hovered');
		}
	}
}).on("mouseleave", function(e) {
	e.stopPropagation();
	var codes = $(this).attr('class').split(' ');
	for (let i = 0; i < codes.length; ++i) {
		var code = codes[i];
		if (code != 'P' && code != 'BR') {
			$('svg.directory-map .' + code).css('fill', '#395FE4');
			$('.directory-section .location-' + code).removeClass('hovered');
		}
	}
});
$(document).on('click', '.directory-section .location[data-id]', function(e) {
	var locationId = $(this).data('id');
	$('aside.panel-location').fadeOut();
	$('aside.panel-location[data-id="' + locationId + '"]').fadeIn('flex');
	$('body').addClass('overflow-hidden');
});
$(document).on('click', 'aside.panel-location svg', function(e) {
	$('aside.panel-location').fadeOut();
	$('body').removeClass('overflow-hidden');
});
$(document).on('click', '.directory-section .map-zoom', function(e) {
	$('aside.panel-map').fadeIn('flex');
	$('body').addClass('overflow-hidden');
});
$(document).on('click', 'aside.panel-map svg', function(e) {
	$('aside.panel-map').fadeOut();
	$('body').removeClass('overflow-hidden');
});
$(document).on('click', 'svg.directory-map [class]', function(e) {
	e.stopPropagation();
	var codes = $(this).attr('class').split(' ');
	if ($('.directory-section .location-' + codes[0] + '[data-id]').length) {
		$('.directory-section .location-' + codes[0]).trigger('click');
	} else {
		$('.directory-section .location-' + codes[1]).trigger('click');
	}
});
$(document).on('click', '.directory-section .location[data-p]', function(e) {
	if ($('.video-section a').length) {
		$('.video-section a').trigger('click');
	}
});



// ACCORDION
$(document).on('click', '.accordion:not(.is-open)', function(e) {
	$(this).addClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	var maxH = content.find('div').outerHeight() + 40;
	content.css('max-height', maxH);
});
$(document).on('click', '.accordion.is-open', function(e) {
	$(this).removeClass('is-open');
	var content = $(this).parent().find('.accordion-content');
	content.removeAttr('style');
});




function footer() {
	if ($(window).width() >= 1696) {
		var footer = $('footer');
		var placeholder = $('.footer-placeholder');
		var footerH = footer.outerHeight();
		placeholder.height(footerH);
		if ($(window).height() < footerH) {
			footer.removeClass('footer-fixed');
			placeholder.addClass('hide');
		} else {
			footer.addClass('footer-fixed');
			placeholder.removeClass('hide');
		}
	}
}



function heroSection() {
	if ($('.quick-links-section').length) {
		document.documentElement.style.setProperty('--ql-height', `${$('.quick-links-section').outerHeight()}px`);
	} else {
		document.documentElement.style.setProperty('--ql-height', `0px`);
	}
}





// INFO CARDS
$(document).on('click', '.info-cards-section .show-more', function(e) {
	var row = $(this).parent().parent();
	row.fadeOut();
	var section = row.parent().parent();
	section.find('.row-blocks .column > div').addClass('shown');

});